import React, { Component } from 'react';
import '../languageSelect.css';
import Translate from "localization/Translate";
import {getLanguages, localeSelected} from "localization/localizeSlice";
import {connect} from "react-redux";
import ClickAwayListener from "react-advanced-click-away";
import FlagImage from "./FlagImage";
import DownArrow from "../../icons/DownArrow";


const mapDispatchToProps = dispatch => {
    return {
        setLocale: (locale) => {
            dispatch(localeSelected(locale));
        }
    }
}

const mapStateToProps = state => {
    let locale = state.localize.activeLocale;

    return {
        locale,
        languages: getLanguages(state)
    }
};

class LanguageSelect extends Component{
    constructor(props){
        super(props);

        this.state = {
            isOpen: false
        };
    }

    toggleSelect(){
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    changeLocale(e, locale){
        this.props.setLocale(locale);
    }

    render() {
        let languages = this.props.languages.map((languageCode) => {
            return(
                <li className={"languageItem"} key={languageCode} onClick={e => this.changeLocale.bind(this)(e, languageCode)}>
                    <FlagImage locale={languageCode} style={{width: "2.5rem"}}/>
                    <span>
                        <Translate id={languageCode}/>
                    </span>
                </li>
            );
        });

        return (
            <div className={"languageSelectContainer"} onClick={this.toggleSelect.bind(this)}>
                <FlagImage locale={this.props.locale} style={{float:"left", width: "2.5rem"}}/>
                <DownArrow style={{padding: "0.86rem 0.36rem", color: "var(--coloredText)"}}/>
                {this.state.isOpen &&
                    <ClickAwayListener onClickAway={this.toggleSelect.bind(this)}>
                        <div className={"languageListContainer"}>
                            <div className={"triangle-with-shadow"}/>
                            <div className={""}>
                               <ul>{languages}</ul>
                            </div>
                        </div>
                    </ClickAwayListener>
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
